/* Schema see models/invitation/ */

import invitationModelDefinition from '../../invitation';

export default {
  schema: invitationModelDefinition.schema
}
